import '../static/ContentGrid.css';
import React__default, { forwardRef, useMemo } from "react";
import clsx from "clsx";
import { a as Grid } from "./Grid.QyNjlydO.mjs";
import { C as Col } from "./Col.COJSUXXS.mjs";
import { s as sword } from "./sword.DtiKVPhx.mjs";
import { u as useBetterMediaQuery } from "./useBetterMediaQuery.xTM_WrtF.mjs";
const contentGrid = `_contentGrid_511336c`;
const gridItem = `_gridItem_dfeefd2`;
const columns2 = `_columns2_4ac363b`;
const columns3 = `_columns3_470a2d0`;
const columns4 = `_columns4_778f838`;
const _default = `_default_b402342`;
const gap = `_gap_649bd82`;
const center = `_center_388fe3e`;
const styles = { contentGrid, gridItem, columns2, columns3, columns4, "default": _default, gap, center };
const GRID_COLS_LG = parseInt(sword.container.columns.lg, 10);
const GRID_COLS_MD = parseInt(sword.container.columns.md, 10);
const NUMBER_COLUMNS = [1, 2, 3, 4];
const STRING_COLUMNS = NUMBER_COLUMNS.map(
  String
);
const CONTENT_GRID_LAYOUTS = ["default", "gap"];
const CONTENT_GRID_COLUMNS = [
  ...NUMBER_COLUMNS,
  ...STRING_COLUMNS
];
function getGridALignment({
  columnCount,
  layout,
  xAlign = "left",
  isDesktop = false
}) {
  if (columnCount === 2 && layout === "gap" && isDesktop) {
    return "left";
  }
  if (columnCount === 4) {
    return "center";
  }
  return xAlign;
}
const ContentGridInner = ({
  as = "ul",
  colAs = "li",
  className,
  children,
  columnCount = 3,
  layout = "default",
  xAlign,
  ...props
}, ref) => {
  const isDesktop = useBetterMediaQuery(
    `(min-width: ${sword.breakpoints.minLg})`
  );
  const columnsCount = useMemo(
    () => Math.min(Math.max(Number(columnCount), 2), 4),
    [columnCount]
  );
  const gridAlign = getGridALignment({
    columnCount: columnsCount,
    layout,
    xAlign,
    isDesktop
  });
  if (!(children == null ? void 0 : children.length) || children.length < 2) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement(
    Grid,
    {
      as,
      ref,
      className: clsx(
        styles.contentGrid,
        styles[gridAlign],
        styles[`columns${columnsCount}`],
        {
          [styles[layout]]: children.length > 2
        },
        className
      ),
      xAlign: gridAlign,
      "data-ui-content-grid": true,
      ...props
    },
    React__default.Children.map(children, (child, index) => /* @__PURE__ */ React__default.createElement(
      Col,
      {
        "data-testid": "content-grid-col",
        key: index,
        as: colAs,
        className: styles.gridItem,
        md: GRID_COLS_MD / 2,
        lg: GRID_COLS_LG / Number(columnCount)
      },
      child
    ))
  );
};
const ContentGrid = forwardRef(
  ContentGridInner
);
export {
  CONTENT_GRID_LAYOUTS as C,
  CONTENT_GRID_COLUMNS as a,
  ContentGrid as b
};
//# sourceMappingURL=ContentGrid.Bk7uBKEc.mjs.map
